<template>
  <div class="data-center">
    <!-- 我的班级 -->
    <div class="total-box">
      <!-- 班级总数 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="header-title">我的班级总数</span>
          <el-tooltip class="item" effect="dark" content="我的班级总数=常规班+有效的临时班" placement="top-end">
            <i class="el-icon-info" style="color:#67C23A"></i>
          </el-tooltip>
        </div>
        <div class="total-show">
          <div class="total-num"><span>{{class_num}}个</span></div>
          <div class="total-img"><img src="../../../assets/images/teacher/total0.png" alt=""></div>
        </div>
      </el-card>
      <!-- 学生总数 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="header-title">我的学生总数</span>
          <el-tooltip class="item" effect="dark" content="我的学生总数=常规班的学生人数+临时班的学生人数" placement="top-end">
            <i class="el-icon-info" style="color:#67C23A"></i>
          </el-tooltip>
        </div>
        <div class="total-show">
          <div class="total-num"><span>{{student_num}}个</span></div>
          <div class="total-img"><img src="../../../assets/images/teacher/total1.png" alt=""></div>
        </div>
      </el-card>
      <!-- 在线人数 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="header-title">在线人数</span>
          <el-tooltip class="item" effect="dark" content="在线人数=Saas平台在线人数" placement="top-end">
            <i class="el-icon-info" style="color:#67C23A"></i>
          </el-tooltip>
        </div>
        <div class="total-show">
          <div class="total-num"><span>{{on_line}}个</span></div>
          <div class="total-img"><img src="../../../assets/images/teacher/total2.png" alt=""></div>
        </div>
      </el-card>
    </div>
    <!-- 学习统计 -->
    <div class="learn-statistics">
      <div class="learn-header">
        <div class="learn-header-title">学习统计</div>
        <div class="learn-header-search">
          <div class="header-search-item">
            <el-select v-model="class_type" placeholder="请选择" disabled>
              <el-option label="常规班" :value="1" :key="1">
              </el-option>
              <el-option label="临时班" :value="2" :key="2">
              </el-option>
            </el-select>
            <el-select v-model="class_id" placeholder="请选择" @change="classChange">
              <!-- <el-option label="全部" :value="null" :key="null">
              </el-option> -->
              <el-option v-for="(item,index) in class_temp_options" :key="index" :label="item.bjmc" :value="item.bjid">
              </el-option>
            </el-select>
          </div>
          <div class="header-search-item" v-show="class_type==1">
            <el-radio-group v-model="time_type">
              <el-radio :label="3">备选项</el-radio>
              <el-radio :label="6">备选项</el-radio>
              <el-radio :label="9">备选项</el-radio>
            </el-radio-group>
          </div>
          <div class="header-search-item">
            <el-date-picker value-format="yyyy-MM-dd" :picker-options="pickerOptions" v-model="time_list" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change='timeSelectChange'>
            </el-date-picker>
          </div>
          <div></div>
        </div>
      </div>
      <!-- 柱状图 -->
      <!-- <div class="learn-show">
        <div id="mychart" class="mychart"></div>
      </div> -->
      <div class="learn-show">
        <div id="mychart" class="mychart"></div>
        <el-empty description="暂无数据" class="empty" v-show="is_empty==true"></el-empty>
      </div>
      <!-- <div class="learn-show" v-show="is_empty==true">
       
      </div> -->
    </div>
  </div>
</template>
<script>
import {
  onLineApi,
  ClassStudentNumApi,//上课
  ClassTempOptionsApi,
  dataStatisticsApi,//数据统计
} from '@/api/teacher'
import * as echarts from 'echarts';
import Vue from "vue";
Vue.use(echarts);
import {
  BarChart
} from 'echarts/charts';
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent
} from 'echarts/components';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import {
  CanvasRenderer
} from 'echarts/renderers';
// 注册必须的组件
echarts.use(
  [TitleComponent, TooltipComponent, GridComponent, BarChart, CanvasRenderer]
);
export default {
  data() {
    return {
      is_empty: true,
      yhid: this.$store.state.userInfo.yhid,
      zhid: this.$store.state.userInfo.zhid,
      on_line: 0,//在线人数
      class_num: 0,//班级数
      student_num: 0,//学生数
      class_type: 2,//常规班1 临时版2
      time_type: null,
      class_temp_options: [],
      class_id: null,
      time_list: [],//时间选择
      time_section: [],//可选择时间区间
      data_list: [],
      pickerOptions: {
        disabledDate: (time) => {
          return this.dealDisabledDate(time)
        }
        // onPick(time) {
        //   //当第一时间选中才设置禁用
        //   if (time.minDate && !time.maxDate) {
        //     vm.timeOptionRange = time.minDate;
        //   }
        //   if (time.maxDate) {
        //     vm.timeOptionRange = null;
        //   }
        // }
      },
      option: {
        grid: {
          left: '100px',
          right: '0',
          bottom: '50px',
          containLabel: true,
        },
        // 图例
        legend: {
          orient: 'vertical',
          x: 'top',      //可设定图例在左、右、居中
          y: 'left',
          padding: ['80', '10'],    //可设定图例在上、下、居中
          formatter: function (name) {
            // console.log(name)
            const show_text = name == 'shcslv' ? '熟词' : name == 'jscslv' ? '夹生词' : name == 'scslv' ? '生词' : ''
            return show_text
          },
          data: ['product', 'shcslv', 'jscslv', 'scslv']
        },
        // 滑动显示工具栏
        tooltip: {
          trigger: 'axis',
          formatter: function (val) {
            const v = val[0].data
            const text =
              "<span style='font-weight:600;color:#666;line-height:30px'>" + v.product + "</span>" + "<br/>"
              + "<span style='color:#39A0FF'>熟&nbsp;&nbsp;&nbsp;词</span> " + "&nbsp;&nbsp;&nbsp;&nbsp;" + v.shcslv.toFixed(2) + "%" + "<br/>"
              + "<div'><span style='color:#4ECB73'>夹生词</span>" + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + + v.jscslv.toFixed(2) + "% " + "</div><br/>"
              + "<span style='color:#FBD437'>生&nbsp;&nbsp;&nbsp;词</span>" + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + v.scslv.toFixed(2) + "%"
            return text;
          },
          shadowColor: "#E4E7ED",
        },
        color: ["#39A0FF", "#4ECB73", "#FBD437"],
        dataset: {
          source: [
            // { product: 'Matcha Latt2021-', 'shcslv': 43.3, 'jscslv': 85.8, 'scslv': 93.7 },
          ]
        },
        xAxis: { type: 'category', boundaryGap: true },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              show: true,
              interval: 'auto',
              // formatter: function (name) {
              //   console.log(name)
              //   return name+'%'
              //   // console.log(name)
              // }
              formatter: '{value} %',
              // console.log(name)
            },
            show: true,
          }
        ],
        series: [
          {
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  fontSize: '0.6rem',
                  color: '#333'
                },
                formatter: function (val) {
                  // return val.data.shcsl;
                  return val.data.shcslv ? val.data.shcslv.toFixed(2) + '%' : '';
                },
                color: '#000',

              },

            },
            barWidth: 30,
          },
          {
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  fontSize: '0.6rem',
                  color: '#333'
                },
                formatter: function (val) {
                  // return val.data.jscsl;
                  return val.data.jscslv ? val.data.jscslv.toFixed(2) + '%' : '';
                },
              }
            },
            barWidth: 30,
          },
          {
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  fontSize: '0.6rem',
                  color: '#333'
                },
                formatter: function (val) {
                  // return val.data.scsl;
                  return val.data.scslv ? val.data.scslv.toFixed(2) + '%' : '';
                },
              }
            },
            barWidth: 30,
          },
          // {
          //   type: 'bar',
          //   label: {
          //     normal: {
          //       show: true,
          //       formatter: '',
          //       color: '#fff'
          //     }
          //   },
          //   data: [22, 33, 44, 55, 66, 77, 88]
          // },
          // {
          //   type: 'bar',
          //   label: {
          //     normal: {
          //       show: true,
          //       formatter: '',
          //       color: '#fff'
          //     }
          //   },
          //   data: [22, 33, 44, 55, 66, 77, 88]
          // },
        ],
        dataZoom: [
          {
            show: true, //是否显示下方滚动条
            realtime: true,
            start: 0, //显示数据开始位置
            end: 20 //显示数据结束位置
          },
          {
            type: 'inside',
            realtime: true,
            start: 0,
            end: 100
          }
        ]
      }
    }
  },
  mounted() {
    this.getOnLine()
    this.getClassStudentNum()
    this.myEcharts()
    this.$nextTick(function () {
      this.getClassOptions()
    })
  },
  methods: {
    // 获取在线人数个
    getOnLine() {
      onLineApi({ yhid: this.yhid }).then(res => {
        if (res.resultDesc == 'SUCCESS') {
          this.on_line = res.result
        }
      })
    },
    // 获取在线人数和编辑总数
    getClassStudentNum() {
      ClassStudentNumApi({ yhid: this.yhid, zhid: this.zhid,yycdid: this.$store.state.yycdid  }).then(res => {
        if (res.resultDesc == 'SUCCESS') {
          this.class_num = res.result.classCount;
          this.student_num = res.result.studentCount
        }
      })
    },
    // 临时班级下拉
    getClassOptions() {
      ClassTempOptionsApi({ yhid: this.yhid, zhid: this.zhid,yycdid: this.$store.state.yycdid  }).then(res => {
        if (res.resultDesc == 'SUCCESS') {
          this.class_temp_options = res.result;
          this.class_id = res.result[0].bjid;
          this.classChange()
        }
      })
    },
    // 临时班级改变
    classChange() {
      const result = this.class_temp_options.find(m => {
        return m.bjid == this.class_id
      })
      console.log(result)
      if (result) {
        // this.time_section = [result.yxqq, result.yxqz];
        this.time_section = [new Date(result.yxqq).Format("yyyy-MM-dd"), new Date(result.yxqz).Format("yyyy-MM-dd")]
        this.time_list = [new Date(result.yxqq).Format("yyyy-MM-dd "), new Date(result.yxqz).Format("yyyy-MM-dd")]
        // this.time_list = [result.yxqq, result.yxqz];
        this.getDataStatistics()
      }
    },
    dealDisabledDate(time) {
      let srart = new Date(this.$utils.getNowTime(0, 0, -1, this.time_section[0])).getTime();
      let now = new Date(this.$utils.getNowTime(0, 0, 0,)).getTime()
      let end = new Date(this.time_section[1]).getTime();
      if (end > now) {
        end = now
      }
      // if (new Date(this.time_section[1]).getTime() > new Date(this.$utils.getNowTime(0, 0, 0,).getTime())) {
      //  end = new Date(this.$utils.getNowTime(0, 0, 0,).getTime())
      // }
      return time < srart || time > end
    },
    // 时间选择改变
    timeSelectChange() {
      this.getDataStatistics()
    },
    // 获取柱状图数据
    getDataStatistics() {
      const data = {
        bjid: this.class_id,
        startTime: this.time_list[0],
        endTime: this.time_list[1],
      }
      dataStatisticsApi(data).then(res => {
        if (res.resultDesc == 'SUCCESS') {
          this.data_list = res.result;
          // this.data_list.forEach((item, index) => {
          //   item.total_word = item.jscsl + item.shcsl + item.scsl;
          //   item.product = item.dayTime;
          //   if (item.total_word == 0) {
          //     item.shcslv = 0.00
          //     item.jscslv = 0.00
          //     item.scslv = 0.00
          //   } else {
          //     // 计算熟次率
          //     item.shcslv = item.shcsl / item.total_word * 100;
          //     // 计算夹生词率
          //     item.jscslv = item.jscsl / item.total_word * 100;
          //     // 计算生词率
          //     item.scslv = item.scsl / item.total_word * 100
          //   }
          // })
          // if (this.data_list.length == 0) {
          //   this.is_empty = true;
          //   console.log(this.is_empty)
          //   this.$message.warning('暂时没有数据哦')
          //   return false
          // } else {
          //   this.is_empty = this.data_list.every(function (item) {
          //     return item.total_word == 0
          //   })
          //   if (this.is_empty) {
          //     this.$message.warning('暂时没有数据哦')
          //     return false
          //   }
          // }
          // let init_data = [];
          // this.data_list.forEach(item => {
          //   const obj = {
          //     product: item.product,
          //     shcslv: item.shcslv,
          //     jscslv: item.jscslv,
          //     scslv: item.scslv,
          //     shcsl: item.shcsl,
          //     jscsl: item.jscsl,
          //     scsl: item.scsl,
          //   }
          //   init_data.push(obj)
          // })
          // -------------------第二次代码
          if (this.data_list.length > 0) {
            this.is_empty = false;
          }
          let init_data = [];
          this.data_list.forEach(item => {
            const obj = {
              product: item.dayTime,
              shcslv: item.sucl * 100,
              jscslv: item.jscl * 100,
              scslv: item.shcl * 100
            }
            init_data.push(obj)
          })
          // -------------------第二次代码end
          this.option.dataset.source = init_data
          this.myEcharts()
        }
      })
    },
    // chart 调用
    myEcharts() {
      var myChart = echarts.init(document.getElementById("mychart"));
      // 基于准备好的dom，初始化echarts实例
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(this.option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.total-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.box-card {
  width: 28%;
  ::v-deep .el-card__header {
    border-bottom: none;
    .clearfix {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  ::v-deep .el-card__body {
    padding-top: 0;
  }
  .header-title {
    font-size: 14px;
    color: #666;
  }
  .total-num {
    font-size: 28px;
  }
  .total-img {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
// 学习统计
.data-center {
  // height: calc(100% - 50px);
  height: 100%;
}
.learn-statistics {
  padding-top: 20px;
  height: calc(100% - 150px);
  .learn-header {
    width: 100%;
    height: 50px;
    border-bottom: 2px solid #eee;
    display: flex;
    justify-content: space-between;
  }
  .learn-header-title {
    display: inline-block;
    font-size: 22px;
    line-height: 48px;
    color: #409eff;
    border-bottom: #409eff solid 3px;
  }
  .learn-header-search {
    display: flex;
    align-items: center;
  }
  .header-search-item {
    margin: 0 10px;
  }
  .learn-show {
    width: 95%;
    height: calc(100% - 70px);
    position: relative;
    ::v-deep .mychart {
      width: 100%;
      height: 100%;
    }
    ::v-deep .empty {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;
      opacity: 1;
    }
    // background-color: red;
  }
}
</style>

